export const finbotThemeConfig = {
  // Branding configuration
  branding: {
    name: 'ChatbotFinbot',
    logo: '/Assets/Images/logo_so_vn.png',
    type: 'finbot'
  },

  // Appearance customization settings (disabled for Finbot)
  appearance: {
    enableCustomization: false,
    allowLogoUpload: false,
    allowNameChange: false,
    allowThemeChange: false
  },

  // Embed functionality configuration
  embed: {
    loaderUrl: 'https://citeka.promete.ai/loader.min.js',
    embedUrl: '/embed'
  },

  // Authentication and feature flags (uses mock auth)
  features: {
    keycloak: false,
    mockAuth: true
  },

  // Default API configuration (not currently used)
  api: {
    defaultUrl: '/graphql'
  },

  // Keycloak configuration (not used since mockAuth is true)
  keycloak: {
    defaultRealm: '',
    defaultClientId: ''
  }
} as const;

export type FinbotThemeConfig = typeof finbotThemeConfig;
